<template>
    <div class="batch-import-wrapper">
        <TitleBaseBox class="batch-import-box" :title="$t('zhiji.knowlege.importModal.batchImport')" :noButton="true" @close="close">
            <div class="import-content">
                <!-- <p class="tip">{{ $t("zhiji.knowlege.importModal.errorTip1") }}</p> -->
                <div class="import-one">
                    <i class="i-cir">1</i>
                    <div>{{ $t("zhiji.knowlege.importModal.step1Tips") }}</div>
                    <div class="show-portrait-cotent">
                        <a href="javascript:;" class="a-dowload" @click="downLoad">{{ $t("zhiji.knowlege.importModal.downloadTemp") }}</a>
                    </div>
                </div>
                <div class="import-two">
                    <i class="i-cir">2</i>
                    <div>{{ $t("zhiji.knowlege.importModal.step2Tips") }}</div>
                    <div>
                        <label for="file">
                            <span class="btn-file" @click="flag = false">
                                {{ $t("zhiji.knowlege.importModal.uploadFile") }}
                                <input
                                    ref="fileInput"
                                    class="file-input"
                                    name="file"
                                    type="file"
                                    @change="upLoadFile"
                                    accept=".csv"
                                    id="file"
                                    style="display: none"
                                />
                            </span>
                        </label>
                        <span class="file-name">{{ fileName }}</span>
                    </div>
                    <div class="popbtn import-btn-box">
                        <RoundButton :cls="cancelCls" @btnClick="cancelClick" :text="$t('zhiji.common.cancel')"></RoundButton>
                        <RoundButton :cls="importCls" @btnClick="importClick" :text="$t('zhiji.common.import')"></RoundButton>
                    </div>
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import { isUtf8Encoding } from "@/views/zhiji/js/common/util.js";
import { STATIC_RESOURCE_PATH } from "@/views/zhiji/js/common/constants.js";
import i18n from "@/i18n";
import { importEntityApi } from "../server"

export default {
    name: "ImportEntity",
    props: ["data"],
    components: {
        TitleBaseBox,
        RoundButton
    },
    data() {
        return {
            cancelCls: "cancel-btn",
            importCls: "import-btn ",
            importResult: {},
            file: "",
            isShowResult: false,
            flag: false,
            fileName: i18n.t("zhiji.knowlege.importModal.fileType")
        };
    },
    methods: {
        cancelClick() {
            this.flag = false;
            this.$refs.fileInput.value = "";
            this.fileName = i18n.t("zhiji.knowlege.importModal.fileType");
            this.importResult = {};
            this.isShowResult = false;
            this.close();
        },
        importClick(close) {
            if (this.fileName === i18n.t("zhiji.knowlege.importModal.fileType")) {
                this.showMessageTip(i18n.t("zhiji.knowlege.importModal.errorTip2"));
                this.isShowResult = false;
            } else {
                let fileData = new FormData();
                fileData.append("table_file", this.file);
                fileData.append("game_id", this.data.gameId);
                if (this.flag) {
                    return;
                }
                importEntityApi(fileData).then(res => {
                    this.isShowResult = true;
                    this.importResult = res;
                    this.flag = true;
                })
                this.showMessageTip(i18n.t("zhiji.knowlege.importModal.importTip"), "success");
            }
            close && this.close();
        },
        close() {
            this.$emit("closeModal");
            this.data.cancel && this.data.cancel.call(null);
        },
        downLoad() {
            window.open(`${STATIC_RESOURCE_PATH}entity_templet.csv`);
        },
        upLoadFile(e) {
            this.importResult = {};
            this.isShowResult = false;
            let file = (this.file = e.target.files[0]);
            if (file) {
                let fileName = file.name;
                if (fileName != "") {
                    let file_suffix = fileName.substr(fileName.lastIndexOf("."));
                    if (file_suffix != ".csv" && fileName) {
                        this.showMessageTip(i18n.t("zhiji.knowlege.importModal.errorTip3"));
                        return;
                    }
                    this.fileName = fileName;
                }
            }
            isUtf8Encoding(file)
                .then(() => {})
                .catch(err => {
                    this.fileName = i18n.t("zhiji.knowlege.importModal.fileType");
                    this.showMessageTip(err);
                    this.file = "";
                });
        },
        showMessageTip(message, type) {
            this.$message({
                message: message,
                center: true,
                showClose: true,
                duration: 3000,
                type: type || "warning"
            });
        }
    }
};
</script>

<style scoped lang="less">
.batch-import-wrapper {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    .batch-import-box {
        width: 500px;
    }
    .tip {
        color: #ff782b;
        margin-bottom: 20px;
    }
    .import-content {
        padding: 0px 23px 0 0px;
    }
    .textarea {
        width: 438px;
        height: 306px;
        padding: 5px;
        color: rgba(65, 71, 94, 0.9);
        overflow-y: auto;
        outline: none;
        border: 1px solid #d8e4f0;
        border-radius: 4px;
        resize: none;
        box-sizing: border-box;
        overflow-x: hidden;
        word-wrap: break-word;
    }
    .import-one,
    .import-two {
        position: relative;
        padding-left: 33px;
        margin-bottom: 20px;
    }
    .import-one,
    .import-two {
        > div {
            margin-bottom: 14px;
        }
    }
    .show-portrait-cotent {
        position: relative;
    }
    .i-cir {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 2px;
        left: 0;
        width: 18px;
        height: 18px;
        line-height: 20px;
        background: #41475e;
        border-radius: 50%;
        color: #fff;
        font-style: normal;
    }
    .btn-file {
        position: relative;
        display: inline-block;
        width: 88px;
        line-height: 32px;
        height: 32px;
        margin-right: 10px;
        text-align: center;
        color: #41475e;
        border: 1px solid #d8e4f0;
        border-radius: 4px;
        cursor: pointer;
    }
    .file-input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    }
    .file-name {
        color: #9b9ba3;
    }
    .import-btn-box {
        text-align: right;
    }
    .import-result-tip {
        margin-bottom: 5px;
    }
    .a-dowload {
        color: #2088f3;
        text-decoration: underline;
        &:before {
            display: inline-block;
            content: "";
            margin-right: 4px;
            width: 16px;
            height: 15px;
            vertical-align: -2px;
            background: url("@{zhijiStaticImagePath}i-dowload.png") no-repeat;
        }
    }
}

.import-btn {
    box-shadow: none !important;
}
</style>
